import React, { useEffect, useState } from "react";
import { View, Text, TextInput } from "@constants/Themed";
import { ValidationType } from "../types/validatorTypes";
import updateStoreHandler from '../utils/updateStoreHandler';
import { Switch, Pressable } from "react-native";
import styles from "@stylesheet";
import { Foundation } from '@expo/vector-icons';
import ComponentRenderer from "./ComponentRenderer";
import defaultValComponents, { ValidationComponentType } from "../utils/defaultValComponents";

const DropdownValidation = ({item, index}: ValidationType) => {


  // Define an array of configuration objects for each component
  const validationComponents: ValidationComponentType[] = [
    ...defaultValComponents,
    { key: 'options', label: 'Options', type: 'options' },
    { key: 'multiSelect', label: 'Multi-Select?', type: 'switch' },
    { key: 'minSelections', label: 'Min Selections', type: 'textInput', inputMode: 'numeric' },
    { key: 'maxSelections', label: 'Max Selections', type: 'textInput', inputMode: 'numeric' },
    { key: 'defaultSelections', label: 'Default Selections', type: 'textInput' },
    { key: 'allowOther', label: 'Allow Other?', type: 'switch' },
    { key: 'otherText', label: 'Other Text', type: 'textInput' },
  ];



  return (
    <View style={[styles.validationView, { flexWrap: 'wrap' }]}>
      {validationComponents.map((component) => (
        <View key={component.key} style={{ flexDirection: 'row', alignItems: 'center', alignSelf: 'stretch', position: 'relative', flexWrap: 'wrap' }}>
          {
            component.type === 'switch' &&
            <Text style={{ flex: 1 }}>{component.label}</Text>
          }
          <ComponentRenderer item={item} component={component} index={index} />
        </View>
      ))}
    </View>
  );
};

export default DropdownValidation;
